import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import "../../Css/Dashcrud.css";

export default function FormUpdateProd() {
  const [menuData, setMenuData] = useState({});
  const [categoria, setCategoria] = useState("");
  const [subcategoria, setSubcategoria] = useState("");
  const [tipo, setTipo] = useState("");

  const [field, setField] = useState("");
  const [value, setValue] = useState("");
  const [docId, setDocId] = useState("");

  useEffect(() => {
    const loadMenu = async () => {
      const menu = {};
      const catSnap = await getDocs(collection(db, "Menu"));

      for (const cat of catSnap.docs) {
        menu[cat.id] = {};
        const subSnap = await getDocs(
          collection(db, `Menu/${cat.id}/subcategoria`)
        );

        for (const sub of subSnap.docs) {
          menu[cat.id][sub.id] = true;
        }
      }
      setMenuData(menu);
    };
    loadMenu();
  }, []);

  const atualizar = async () => {
    if (!categoria || !subcategoria || !tipo || !docId) {
      alert("Preencha todos os campos");
      return;
    }

    const ref = doc(
      db,
      `Db/${categoria}/${subcategoria}/${tipo}/${docId}`
    );

    await updateDoc(ref, {
      [field]: field === "price" ? Number(value) : value
    });

    alert("✅ Produto atualizado com sucesso");
  };

  return (
    <div className="container">
      <h1 className="title" >Atualizar Produto</h1>

      <div className="card">
        <select className="selecter" onChange={e => setCategoria(e.target.value)}>
          <option value="">Categoria</option>
          {Object.keys(menuData).map(c => (
            <option key={c}>{c}</option>
          ))}
        </select>

        <select className="selecter" onChange={e => setSubcategoria(e.target.value)}>
          <option value="">Subcategoria</option>
          {categoria &&
            Object.keys(menuData[categoria]).map(s => (
              <option key={s}>{s}</option>
            ))}
        </select>

        <input
          className="inputer"
          placeholder="Tipo / Produto (ex: produtos)"
          onChange={e => setTipo(e.target.value)}
        />

        <input
         className="inputer"
          placeholder="ID do documento"
          onChange={e => setDocId(e.target.value)}
        />

        <select className="selecter" onChange={e => setField(e.target.value)}>
          <option value="">Campo a atualizar</option>
          <option value="produto">Nome do Produto</option>
          <option value="price">Preço</option>
          <option value="category">Categoria</option>
          <option value="description">Descrição</option>
        </select>

        <input
          className="inputer"
          placeholder="Novo valor"
          onChange={e => setValue(e.target.value)}
        />

        <button className="button" onClick={atualizar}>Atualizar</button>
      </div>
    </div>
  );
}
